import React, { FC, MouseEvent, useContext } from "react";
import { List, ListItem, Typography } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { remove } from "lodash";
import { FiltersContext } from "../../context";
import Header from "../Common/Header";
import StyledTooltip from "../Common/StyledTooltip";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: "0.8rem",
  },
  list: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    paddingBottom: 0,
  },
  listItemUnselected: {
    width: "auto",
    margin: "0 4px 4px 0",
    padding: "8px 24px",
    color: theme.palette.secondary.dark,
    backgroundColor: theme.palette.background.default,
    "&:hover": {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  listItemSelected: {
    width: "auto",
    margin: "0 4px 4px 0",
    padding: "8px 24px",
    color: theme.palette.background.default,
    backgroundColor: theme.palette.secondary.dark,
    "&:hover": {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.secondary.main,
    },
  },
  newImage: {
    height: 16,
    marginLeft: 5,
  },
}));

interface SearchSectionProps {
  title: string;
  searches: object | Array<string>;
  showNewIconNextToTitle?: boolean;
  onlyOneSelection?: boolean; // i.e. only one item in group can be selected
}

const SearchSection: FC<SearchSectionProps> = ({
  title,
  searches,
  showNewIconNextToTitle = false,
  onlyOneSelection = false,
}) => {
  const classes = useStyles();

  const [filtersContext, setFiltersContext] = useContext(FiltersContext);

  const handleSelect = (e: MouseEvent<HTMLElement>, filterSection, filter) => {
    const isAlreadySelected = filtersContext[filterSection].includes(filter);

    const filterUpdate = {};
    if (isAlreadySelected || !onlyOneSelection) {
      const newFilters = isAlreadySelected
        ? remove(filtersContext[filterSection], (value) => value !== filter)
        : [...filtersContext[filterSection], filter];

      filterUpdate[filterSection] = newFilters;
    } else {
      // if filter is not already selected, remove all existing filters from this row, so that only one at a time can be selected
      // (although note that you can also have NONE selected)
      Object.keys(searches).map((key) => {
        const fs = searches[key].section;
        filterUpdate[fs] = [];
      });
      filterUpdate[filterSection] = [filter];
    }
    setFiltersContext({
      ...filtersContext,
      ...filterUpdate,
    });
  };

  const renderItem = (key, filterSection, isSelected) => {
    return (
      <span key={key}>
        <ListItem
          button
          className={isSelected ? classes.listItemSelected : classes.listItemUnselected}
          onClick={(e) => handleSelect(e, filterSection, searches[key].keyword)}
        >
          <Typography variant="body2">{key}</Typography>
        </ListItem>
      </span>
    );
  };

  const renderTooltipItem = (key, filterSection, isSelected, text) => {
    return (
      <StyledTooltip title={text} key={key}>
        {renderItem(key, filterSection, isSelected)}
      </StyledTooltip>
    );
  };

  return (
    <div className={classes.container}>
      <Typography variant={"h4"}>
        {title}
        {showNewIconNextToTitle && (
          <img
            alt="New"
            className={classes.newImage}
            src="https://secure.ipdanalytics.com/User/images/banner-new.png"
          />
        )}
      </Typography>

      <List className={classes.list}>
        {Object.keys(searches).map((key) => {
          const filterSection = searches[key].section;
          const hoverText = searches[key].hoverText;
          const isSelected = filtersContext[filterSection].map((x) => x.toLowerCase()).includes(key.toLowerCase());

          return hoverText
            ? renderTooltipItem(key, filterSection, isSelected, hoverText)
            : renderItem(key, filterSection, isSelected);
        })}
      </List>
    </div>
  );
};

/* <div className={classes.container}>
        <Header title="Top Searches" variant="h4" />
        <List className={classes.list}>
          {Object.keys(searches).map((key) => {
            const filterSection = searches[key].section;
            const isSelected = filtersContext[filterSection].includes(key);

            return (
              <span key={key}>
                {key === "IPD Drug Pipeline Report" ? (
                  <StyledTooltip title={TEXTS.PIPELINE_REPORT_TOOLTIP}>
                    <ListItem
                      button
                      className={isSelected ? classes.listItemSelected : classes.listItemUnselected}
                      onClick={(e) => handleSelect(e, filterSection, searches[key].keyword)}
                    >
                      <Typography variant="body2">
                        {key}
                        <span> *</span>
                      </Typography>
                    </ListItem>
                  </StyledTooltip>
                ) : (
                  <ListItem
                    button
                    className={isSelected ? classes.listItemSelected : classes.listItemUnselected}
                    onClick={(e) => handleSelect(e, filterSection, searches[key].keyword)}
                  >
                    <Typography variant="body2">{key}</Typography>
                  </ListItem>
                )}
              </span>
            );
          })}
        </List>
      </div> */
export default SearchSection;
